<template>
  <div>
    
      <!-- <v-breadcrumbs :items="items" class="breadcrumb" >

      </v-breadcrumbs> -->

   
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card v-if="ay_std_div_list != null" class="box">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong>Worksheet Report </strong>
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-row justify="center" dense>
          <v-col sm="2">
            <v-icon color="error">*</v-icon>
            <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
              :items="ay_std_div_list" item-text="ay" label="Academic Year" outlined @change="getStd()" persistent-hint
              hint="Select Academic Year " />
          </v-col>
          <v-col sm="2" v-if="std_div_list != null">
            <v-icon color="error">*</v-icon>
            <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
              :items="std_div_list" item-text="std" label="Standard" outlined @change="getDiv" persistent-hint
              hint="Select Standard " />
          </v-col>
          <v-col sm="2" v-if="div_list != null">
            <v-icon color="error">*</v-icon>
            <v-autocomplete color="#0F2027" dense rounded required v-model="div" return-object :items="div_list"
              item-text="div_name" label="Division" outlined persistent-hint hint="Select Division" />
          </v-col>
          <v-col sm="2" v-if="sel_ay_data && sel_std_data">
            <v-btn class="mt-6 button" color="primary" @click="get_homework_report"
              :loading="fetch_btn_load">Fetch</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <v-row v-if="showSearch" style="margin-top: 5px;">
        <v-col cols="12" sm="6" md="6" v-if="worksheet_list1 != ''">
          <v-btn rounded color="success" outlined @click="fnExcelReport('my-table-id', 'WorkSheetReport')"><v-icon
              color="success">mdi-export</v-icon>Export</v-btn>
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
            hide-details></v-text-field>
        </v-col>



      </v-row>

      <v-data-table :headers="headers" :items="worksheet_list1" :search="search" class="mytable" id="my-table-id"
        v-if="worksheet_list1 != ''" :items-per-page="-1">
        <template v-slot:[`item.isdeleted`]="{ item }">
          <span v-if="item.isdeleted">

            <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
          </span>
          <span v-else>
            <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
          </span>
        </template>
        <template v-slot:item.attachment="{ item }">

          <span style="color: grey" v-if="item.attachment == '-'">--</span>
          <a v-else target="_blank" :href="basepath + item.attachment">Attachment</a>
        </template>
        <template v-slot:top class="pb-5">
          <v-row justify="center" align="center" v-if="worksheet_list1.length > 0">
            <tr class="t-row">
              <div>
                <th>
                  <v-row>
                    <span v-for="header in headers" :key="header.text">
                      <span v-if="filters.hasOwnProperty(header.value)">
                        <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small rounded dense outlined
                          color="#0F2027" :label="header.text" multiple clearable :items="columnValueList(header.value)"
                          v-model="filters[header.value]"></v-autocomplete>
                      </span>
                    </span>
                  </v-row>
                </th>
              </div>
            </tr>
          </v-row>
        </template>
      </v-data-table>
    </v-card>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard

export default {
 
  data: () => ({
    fetch_btn_load: false,
    overlay: false,
    search: "",
    snackbar: false,
  items: [
      { text: "Home", disabled: false, href: "/home-updated" },
      { text: "Work Sheet", disabled: true, href: "" },
    ],
 
    snackbar_msg: "",
    color: "",
    ay_std_div_list: null,
    sel_std_data: null,
    div_list: null,
    std_div_list: null,
    worksheet_list: [],
    basepath: null,
    headers: [
      {
        text: "Sr. No.",
        value: "srno",
        align: "center",
      },
      {
        text: "Worksheet No.",
        value: "worksheet_no",
        align: "center",
      },
      {
        text: "Title",
        value: "title",
        align: "center",
      },
      {
        text: "Course Name",
        value: "course_name",
        align: "center",
      },
      {
        text: "Attachment",
        value: "attachment",
        align: "center",
      },
      {
        text: "Post Date",
        value: "post_date",
        align: "center",
      },
      // {
      //   text: "Creation Date",
      //   value: "creation_date",
      //   align: "center",
      // },
      {
        text: "Updation Date",
        value: "updation_date",
        align: "center",
      },
      {
        text: "Is Deleted?",
        value: "isdeleted",
        align: "center",
      },
    ],
    showSearch: false,
    dialogItem: {
      title: "",
      description: "",
      due_date: "",
      assigned_date: "",
      marks: "",
      course_name: "",
      faculty_name: "",
      is_assignment: "",
      total_students: "",
      total_submissions: "",
      total_evaluations: "",
      attachment: "",
      showSearch: false,
    },
    dialog: false,
    filters: {
      course_name: [],
    },
  }),
  computed: {
    worksheet_list1() {
      return this.worksheet_list.filter((d) => {
        const matchesSearch = Object.keys(d).some(key =>
          String(d[key]).toLowerCase().includes(this.search.toLowerCase())
        );
        const matchesFilters = Object.keys(this.filters).every((f) => {
          return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
        });
        return matchesSearch && matchesFilters;
      });
    },
  },
  mounted() {
    this.get_ay_std();
    this.basepath = localStorage.getItem("awspath");
  },
  methods: {
    fnExcelReport(id, name) {
      var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
      tab_text += "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
      tab_text += "<x:Name>Test Sheet</x:Name>";
      tab_text += "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
      tab_text += "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
      tab_text += "<table border='1px'>";

      // Manually build the table
      var headers = ["Sr. No.", "Worksheet No.", "Title", "Course Name", "Attachment", "Post Date", "Updation Date", "Is Deleted?"];
      tab_text += "<tr>";
      headers.forEach(header => {
        tab_text += "<th style='text-align: center;'>" + header + "</th>";
      });
      tab_text += "</tr>";

      this.worksheet_list1.forEach(item => {
        // Format dates to include AM/PM
        var postDate = new Date(item.post_date).toLocaleString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true
        });
        var updationDate = new Date(item.updation_date).toLocaleString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true
        });

        tab_text += "<tr>";
        tab_text += "<td style='text-align: center;'>" + item.srno + "</td>";
        tab_text += "<td style='text-align: center;'>" + item.worksheet_no + "</td>";
        tab_text += "<td style='text-align: center;'>" + item.title + "</td>";
        tab_text += "<td style='text-align: center;'>" + item.course_name + "</td>";
        tab_text += "<td style='text-align: center;'><a href='" + this.basepath + item.attachment + "'>Attachment</a></td>";
        tab_text += "<td style='text-align: center;'>" + postDate + "</td>";
        tab_text += "<td style='text-align: center;'>" + updationDate + "</td>";
        tab_text += "<td style='text-align: center;'>" + (item.isdeleted ? "Yes" : "No") + "</td>";
        tab_text += "</tr>";
      });

      tab_text += "</table></body></html>";

      var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";
      const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const filename = name + '.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    },







    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    get_ay_std() {
      this.overlay = true;
      //api-1
      axios
        .post("/CommonAPI/get_ay_std_div_for_report")
        .then((res) => {
          this.overlay = false;
          this.ay_std_div_list = res.data.data;
          this.sel_ay_data = res.data.curr_ay;
        })
        .catch((error) => {
          this.overlay = false;
          window.console.log(error);
        })
        .finally(() => {
          this.overlay = false;
          //close loader
        });
    },
    getStd() {
      this.std_div_list = ["All"];
      this.sel_std_data = "All";
      this.div_list = null;
      this.div = null;
      this.std_div_list = this.sel_ay_data.std_list;
      this.std_div_list.unshift("All");
    },
    getDiv() {
      this.div_list = ["All"];
      this.div = "All";
      this.div_list = this.sel_std_data.div_list;
      this.div_list.unshift("All");
      this.div = this.div_list[0];
      if (this.div_list.length == 0) {
        alert("No division found!!!");
        this.div_list = null;
      }
    },
    get_homework_report() {
      this.showSearch = true;
      let div;
      if (this.div != null) {
        div = this.div.div_off_id;
        if (this.div.div_off_id) {
          div = this.div.div_off_id;
        } else {
          div = this.div;
        }
      }
      let ay;
      if (this.sel_ay_data.ay_id) {
        ay = this.sel_ay_data.ay_id;
      } else if (this.sel_ay_data.id) {
        ay = this.sel_ay_data.id;
      }
      let data = {
        current_academic_year_id: ay,
        standard_obj: this.sel_std_data,
        division_off_id: div,
      };
      this.overlay = true;
      axios
        .post("/Homework/worksheet_report", data)
        .then((res) => {
          // this.overlay = false;
          if (res.data.msg == "200") {
            // this.worksheet_list = res.data.worksheet_list;
            // console.log(res.data.worksheet_list.length);
            if (res.data.worksheet_list.length == 0) {
              this.showSnackbar("#b71c1c", "No Data Found!");
              this.worksheet_list = [];
            } else {
              this.worksheet_list = res.data.worksheet_list;
            }
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            //error
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.overlay = false;
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          this.overlay = false;
          //close loader
          this.fetch_btn_load = false;
        });
    },
    view_more(item) {
      // console.log("insinde view_more");
      // console.log(item);
      this.dialogItem = Object.assign({}, item);
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    columnValueList(column) {
      return [...new Set(this.worksheet_list.map(item => item[column]))];
    },
  },
};

</script>

<style scoped>

    .breadcrumb {
  
      padding: 10px;
  
      margin-left: 80px;
      margin-top: -50px;
      font-size: medium;
      font-weight: bold;
    }
</style>